import "./AppHome.css";

type AppHomeProps = {

}   

export const AppHome = ({} : AppHomeProps) => {
    return (
        <>
            AppHome
        </>
    )
}